import { Injectable } from "@angular/core";
import { HttpClient , HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { UserRequest } from "../../shared/models/userRequest";
import { Observable, throwError } from "rxjs";
import { retry, catchError, map, take } from 'rxjs/operators';
import { database } from "firebase";

@Injectable({
  providedIn: "root",
})
export class UserRequestService {
  private api = environment.urlApi;
  private listRequest: UserRequest[] = [];

  
    // Http Headers
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

  constructor(private http: HttpClient) {}

  async getUserRequest(_companyId?, _idUsuario?) {
    try{
      await this.http.get<any>(this.api + "requests/getAllRequests?companyId=" + _companyId + '&idUsuario=' + _idUsuario).toPromise()
      .then((res: any) => {
        if(res && res.data) {
          this.listRequest = res.data;
        }
      }).catch(err => {
        console.log(err);
      });
      console.log(this.listRequest);
      return this.listRequest;
    } catch(err) {
      console.log(err);
      return [];
    }
  }

  updateStatusRequest(_id?,_status?,_email?,_dispersionAmount?,_userName?){
    var data = {'id': _id,'status': _status,'email': _email,'dispersionAmount': _dispersionAmount,'userName':_userName};
    return this.http.post(this.api + 'requests/updateStatus' , JSON.stringify(data),this.httpOptions).pipe(retry(1), catchError(this.errorHandl));
  }

  // Error handling
  errorHandl(error) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
